import { useMemo } from 'react';

/**
 * Determines if the airdrop claim process is active based on environment variable
 */
export const useIsClaimActive = (): boolean => {
  return useMemo(
    () => process.env.NEXT_PUBLIC_APP_CLAIM_CLAIM_ENABLED === 'true',
    [],
  );
};
